// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sJ-z","twoColumnImage":"tJ-z"};